/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
/**
 * RechtResourceApi - axios parameter creator
 * @export
 */
export const RechtResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle möglichen Rechte des Systems ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Rechte des Systems ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRechte: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/konfigurationen/rechte`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RechtResourceApi - functional programming interface
 * @export
 */
export const RechtResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RechtResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle möglichen Rechte des Systems ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Rechte des Systems ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRechte(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRechte(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RechtResourceApi.getAllRechte']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RechtResourceApi - factory interface
 * @export
 */
export const RechtResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RechtResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle möglichen Rechte des Systems ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
         * @summary Endpunkt der alle Rechte des Systems ausliefert.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRechte(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAllRechte(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RechtResourceApi - object-oriented interface
 * @export
 * @class RechtResourceApi
 * @extends {BaseAPI}
 */
export class RechtResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle möglichen Rechte des Systems ausgeliefert.</p><p><b>Benötigte Rechte:</b> ADMIN</p>
     * @summary Endpunkt der alle Rechte des Systems ausliefert.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RechtResourceApi
     */
    public getAllRechte(options?: RawAxiosRequestConfig) {
        return RechtResourceApiFp(this.configuration).getAllRechte(options).then((request) => request(this.axios, this.basePath));
    }
}

